<template>
  <div class="collapse-foot">
    <sidebar-section
        sidebar-type="registration-sidebar"
        :sidebar-id="sidebarUniqueIdx"
        sidebar-title="Registration"
        sidebar-icon="person-badge"
        :session="session"
    />
    <sidebar-section
        sidebar-type="notification-sidebar"
        :sidebar-id="sidebarUniqueIdx"
        sidebar-title="Notification"
        sidebar-icon="megaphone"
        :session="session"
    />
    <sidebar-section
        sidebar-type="sessions-sidebar-google"
        :sidebar-id="sidebarUniqueIdx"
        sidebar-icon="tv"
        :session="session"
        :profile="profile"
        @add-data-click="handleAddDataButtonClick"
    />
    <sidebar-section
        sidebar-type="insights-sidebar"
        :sidebar-id="sidebarUniqueIdx"
        sidebar-title="Insights"
        sidebar-icon="pie-chart"
        :session="session"
        :disabled="true"
    />
  </div>
</template>

<script>
import SidebarSection from "@/components/common/sessionComponents/sidebBar";
export default {
  name: "Session_Action_Buttons",
  components: {
    SidebarSection
  },
  props: {
    sidebarUniqueIdx: {
      type: Number,
      default: 0
    },
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    handleAddDataButtonClick(session)
    {
      this.$emit('add-data-click', session);
    }
  }
};
</script>

<style lang="scss" scoped>
.collapse-foot {
  display: flex;
  justify-content: flex-end;
}
</style>
